import { useState, useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import BrokersafeLogo from 'assets/icons/brokersafe_logo.svg';
import { Radio, notification } from 'antd';
import Button from 'components/Button';
import {
  getCustomerOrganizationRequest,
  getContactShareOrganization,
  addUpdateDwollaCustomerOrganizationRequest,
} from 'services/api';
import { Organziation, CustomerOrganizationResponse } from './types';
import { Root } from './styles';

const ContactShareRequest = () => {
  const [organziation, setOrganization] = useState<Organziation>();
  const [selectedRadioButton, setSelectedRadioButton] = useState('');
  const [customerOrganizationResponse, setCustomerOrganizationResponse] =
    useState<CustomerOrganizationResponse>();
  const [searchParams] = useSearchParams();
  const requestPk = searchParams.get('request');
  const guid = searchParams.get('guid');

  const getOrganizationRequest = useCallback(async () => {
    if (!requestPk) {
      return;
    }

    try {
      const result = await getCustomerOrganizationRequest({
        request_pk: requestPk,
      });
      setCustomerOrganizationResponse(result);
      setSelectedRadioButton(
        result?.Customer_Approved_Date !== null ? 'Approved' : 'Not_Approved',
      );
    } catch (error) {}
  }, [requestPk]);

  const getOrganization = useCallback(async () => {
    if (!guid) {
      return;
    }

    try {
      const organziationRes = await getContactShareOrganization(guid);
      if (organziationRes.Organization_Name) {
        setOrganization(organziationRes);
      }
    } catch (error) {}
  }, [guid]);

  useEffect(() => {
    getOrganization();
  }, [getOrganization]);

  useEffect(() => {
    getOrganizationRequest();
  }, [getOrganizationRequest]);

  const handleChange = (changedValue: string) => () => {
    setSelectedRadioButton(changedValue);
  };

  const handleSubmit = async () => {
    try {
      await addUpdateDwollaCustomerOrganizationRequest({
        request_pk: requestPk,
        is_approved: selectedRadioButton === 'Approved' ? 1 : 0,
      });
      notification.success({
        message: 'Success',
        description: 'Update Customer Organization Requset Successfully',
      });
      getOrganizationRequest();
    } catch (error) {
      notification.error({
        message: 'Failed',
        description: 'Something went wrong',
      });
    }
  };

  return (
    <Root>
      <div className="container">
        <header className="header">
          {organziation?.Organization_Logo_URL && (
            <img
              className="logo-wrapper"
              src={organziation?.Organization_Logo_URL}
              style={{ width: '100%', height: '100%' }}
              alt="brokersafe-logo"
            />
          )}
        </header>
        <p
          style={{ marginTop: 0, marginBottom: 30, overflowWrap: 'break-word' }}
        >
          {customerOrganizationResponse?.Page_Header_Text}
        </p>
        <Radio
          checked={selectedRadioButton === 'Approved'}
          disabled={customerOrganizationResponse?.Submitted_Flag === 1}
          onChange={handleChange('Approved')}
        >
          {customerOrganizationResponse?.Approved_Label_Text}
        </Radio>
        <p
          style={{
            paddingTop: 15,
            paddingLeft: 24,
            paddingRight: 24,
            overflowWrap: 'break-word',
            marginTop: 0,
            marginBottom: 30,
          }}
        >
          {customerOrganizationResponse?.Approved_Description_Text}
        </p>
        <Radio
          checked={selectedRadioButton === 'Not_Approved'}
          disabled={customerOrganizationResponse?.Submitted_Flag === 1}
          onChange={handleChange('Not_Approved')}
        >
          {customerOrganizationResponse?.Not_Approved_Label_Text}
        </Radio>
        <div style={{ width: 100, margin: 'auto', marginTop: 20 }}>
          {customerOrganizationResponse?.Submitted_Flag !== 1 && (
            <Button onClick={() => handleSubmit()}>Submit</Button>
          )}
        </div>
      </div>
      <footer>
        <div className="tifle-logo-wrapper">
          <div>Powered By</div>
          <img src={BrokersafeLogo} alt="brokersafe-logo" />
        </div>
      </footer>
    </Root>
  );
};

export default ContactShareRequest;
